export { default } from './shopping-bag-button';